
export default function Privacy() {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <a href="/" className="text-2xl font-bold text-[#0A66C2]" style={{ fontFamily: '"Pacifico", serif' }}>
                StarSales
              </a>
            </div>
            <div className="hidden md:flex space-x-8">
              <a href="/" className="text-gray-700 hover:text-[#0A66C2] font-medium transition-colors">Home</a>
              <a href="/over-ons" className="text-gray-700 hover:text-[#0A66C2] font-medium transition-colors">Over ons</a>
              <a href="/contact" className="text-gray-700 hover:text-[#0A66C2] font-medium transition-colors">Contact</a>
            </div>
            <div className="flex items-center space-x-4">
              <a href="tel:097010224137" className="text-[#0A66C2] hover:text-[#F57C00] font-medium transition-colors">
                0970 102 241 37
              </a>
              <button className="bg-[#F57C00] text-white px-4 py-2 rounded-full font-medium hover:bg-[#E65100] transition-colors whitespace-nowrap cursor-pointer">
                Gratis check
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#0A66C2] to-[#1976D2] text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
            Privacyverklaring
          </h1>
          <p className="text-xl text-blue-100" style={{ fontFamily: '"Inter", sans-serif' }}>
            Transparantie over hoe wij omgaan met jouw persoonsgegevens
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl p-8 md:p-12 shadow-sm border border-gray-100">
            {/* Header */}
            <div className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Privacyverklaring – StarSales B.V.
              </h2>
              <p className="text-gray-600 font-medium">
                Laatst bijgewerkt: 12/02/2025
              </p>
            </div>

            {/* Content */}
            <div className="prose prose-lg max-w-none" style={{ fontFamily: '"Inter", sans-serif' }}>
              {/* Section 1 */}
              <div className="mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">1</span>
                  Wie zijn wij?
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  StarSales B.V. is een digitaal marketingbureau dat zich richt op het bouwen van websites en het verzorgen van online marketingdiensten. Wij respecteren jouw privacy en gaan zorgvuldig om met persoonsgegevens.
                </p>
                <div className="bg-blue-50 p-6 rounded-lg border-l-4 border-[#0A66C2]">
                  <h4 className="font-bold text-gray-900 mb-3">Bedrijfsgegevens:</h4>
                  <div className="space-y-1 text-gray-700">
                    <p className="font-semibold">StarSales B.V.</p>
                    <p>Mgr. Cornelis Veermanlaan 63</p>
                    <p>1131 KE Volendam – Nederland</p>
                    <p>KvK: 97377562</p>
                    <p>Telefoon: 0970 102 241 37</p>
                  </div>
                </div>
              </div>

              {/* Section 2 */}
              <div className="mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">2</span>
                  Welke persoonsgegevens verwerken wij?
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Wij verwerken persoonsgegevens die je zelf aan ons verstrekt, bijvoorbeeld via ons contactformulier of e-mail. Het kan gaan om:
                </p>
                <div className="grid md:grid-cols-2 gap-4">
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-center">
                      <i className="ri-check-line text-[#0A66C2] mr-2"></i>
                      Voor- en achternaam
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-[#0A66C2] mr-2"></i>
                      Bedrijfsnaam
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-[#0A66C2] mr-2"></i>
                      Adresgegevens
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-[#0A66C2] mr-2"></i>
                      Telefoonnummer
                    </li>
                  </ul>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-center">
                      <i className="ri-check-line text-[#0A66C2] mr-2"></i>
                      E-mailadres
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-[#0A66C2] mr-2"></i>
                      Informatie in berichten/formulieren
                    </li>
                    <li className="flex items-center">
                      <i className="ri-check-line text-[#0A66C2] mr-2"></i>
                      IP-adres (bij websitegebruik)
                    </li>
                  </ul>
                </div>
              </div>

              {/* Section 3 */}
              <div className="mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">3</span>
                  Voor welke doeleinden gebruiken wij jouw gegevens?
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Wij gebruiken jouw persoonsgegevens voor:
                </p>
                <div className="space-y-3">
                  <div className="flex items-start">
                    <i className="ri-arrow-right-circle-line text-[#F57C00] mt-1 mr-3"></i>
                    <p className="text-gray-700">Het beantwoorden van vragen en versturen van offertes</p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-arrow-right-circle-line text-[#F57C00] mt-1 mr-3"></i>
                    <p className="text-gray-700">Het uitvoeren van onze diensten (websites, advertenties, campagnes)</p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-arrow-right-circle-line text-[#F57C00] mt-1 mr-3"></i>
                    <p className="text-gray-700">Het verbeteren van onze website en dienstverlening (analyse en statistieken)</p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-arrow-right-circle-line text-[#F57C00] mt-1 mr-3"></i>
                    <p className="text-gray-700">Het versturen van serviceberichten of updates</p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-arrow-right-circle-line text-[#F57C00] mt-1 mr-3"></i>
                    <p className="text-gray-700">Marketingdoeleinden (met jouw toestemming, bijv. via nieuwsbrieven of remarketing)</p>
                  </div>
                </div>
              </div>

              {/* Section 4 */}
              <div className="mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">4</span>
                  Rechtsgrond voor verwerking
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Wij verwerken persoonsgegevens op basis van:
                </p>
                <div className="grid md:grid-cols-2 gap-4">
                  <div className="bg-green-50 p-4 rounded-lg border-l-4 border-green-500">
                    <p className="text-gray-700 font-medium">Jouw toestemming</p>
                  </div>
                  <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500">
                    <p className="text-gray-700 font-medium">Het uitvoeren van een overeenkomst</p>
                  </div>
                  <div className="bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-500">
                    <p className="text-gray-700 font-medium">Wettelijke verplichting</p>
                  </div>
                  <div className="bg-purple-50 p-4 rounded-lg border-l-4 border-purple-500">
                    <p className="text-gray-700 font-medium">Ons gerechtvaardigd belang</p>
                  </div>
                </div>
              </div>

              {/* Section 5 */}
              <div className="mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">5</span>
                  Bewaartermijn
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Wij bewaren persoonsgegevens niet langer dan nodig is om de doeleinden te realiseren waarvoor ze zijn verzameld, tenzij we wettelijk verplicht zijn gegevens langer te bewaren.
                </p>
              </div>

              {/* Section 6 */}
              <div className="mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">6</span>
                  Delen van gegevens met derden
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Wij delen persoonsgegevens alleen met derden wanneer dit noodzakelijk is voor onze dienstverlening of als wij wettelijk verplicht zijn. Denk aan:
                </p>
                <div className="space-y-3 mb-4">
                  <div className="flex items-center">
                    <i className="ri-server-line text-[#0A66C2] mr-3"></i>
                    <p className="text-gray-700">Hostingproviders en IT-dienstverleners</p>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-bank-card-line text-[#0A66C2] mr-3"></i>
                    <p className="text-gray-700">Betaaldiensten en boekhouding</p>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-advertisement-line text-[#0A66C2] mr-3"></i>
                    <p className="text-gray-700">Marketingtools (zoals Google, Meta/Facebook)</p>
                  </div>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  Met deze partijen sluiten wij verwerkersovereenkomsten om jouw gegevens te beschermen.
                </p>
              </div>

              {/* Section 7 */}
              <div className="mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">7</span>
                  Cookies en tracking
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Wij maken gebruik van cookies en vergelijkbare technieken om de website goed te laten werken, statistieken te verzamelen en gerichte advertenties te tonen. Zie onze{' '}
                  <a href="/cookies" className="text-[#0A66C2] hover:text-[#F57C00] font-medium underline transition-colors">
                    Cookieverklaring
                  </a>{' '}
                  voor meer informatie.
                </p>
              </div>

              {/* Section 8 */}
              <div className="mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">8</span>
                  Jouw rechten
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Je hebt het recht om:
                </p>
                <div className="grid md:grid-cols-2 gap-4 mb-4">
                  <div className="flex items-start">
                    <i className="ri-eye-line text-[#F57C00] mt-1 mr-3"></i>
                    <p className="text-gray-700">Inzage te krijgen in jouw persoonsgegevens</p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-edit-line text-[#F57C00] mt-1 mr-3"></i>
                    <p className="text-gray-700">Gegevens te laten corrigeren of verwijderen</p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-shield-line text-[#F57C00] mt-1 mr-3"></i>
                    <p className="text-gray-700">Verwerking te beperken of bezwaar te maken</p>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-download-line text-[#F57C00] mt-1 mr-3"></i>
                    <p className="text-gray-700">Gegevens over te dragen (dataportabiliteit)</p>
                  </div>
                </div>
                <p className="text-gray-700 leading-relaxed">
                  Wil je gebruikmaken van deze rechten? Neem dan contact met ons op via de contactgegevens hierboven.
                </p>
              </div>

              {/* Section 9 */}
              <div className="mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">9</span>
                  Beveiliging
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Wij nemen passende technische en organisatorische maatregelen om jouw gegevens te beschermen tegen verlies of onrechtmatig gebruik.
                </p>
              </div>

              {/* Section 10 */}
              <div className="mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">10</span>
                  Klachten
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Ben je niet tevreden met hoe wij met jouw gegevens omgaan? Neem eerst contact met ons op. Kom je er niet uit, dan kun je een klacht indienen bij de Autoriteit Persoonsgegevens via{' '}
                  <a 
                    href="https://www.autoriteitpersoonsgegevens.nl" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-[#0A66C2] hover:text-[#F57C00] font-medium underline transition-colors"
                  >
                    www.autoriteitpersoonsgegevens.nl
                  </a>.
                </p>
              </div>

              {/* Section 11 */}
              <div className="mb-10">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="bg-[#0A66C2] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-3">11</span>
                  Wijzigingen
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  StarSales B.V. behoudt zich het recht voor om deze privacyverklaring te wijzigen. Controleer regelmatig deze pagina voor de meest actuele versie.
                </p>
              </div>
            </div>

            {/* CTA Section */}
            <div className="mt-12 pt-8 border-t border-gray-200">
              <div className="text-center">
                <h3 className="text-xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                  Vragen over jouw privacy?
                </h3>
                <p className="text-gray-600 mb-6">
                  Neem contact met ons op voor meer informatie over hoe wij omgaan met jouw gegevens.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <a 
                    href="/contact" 
                    className="inline-flex items-center bg-[#F57C00] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#E65100] transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-mail-line mr-2"></i>
                    Contact opnemen
                  </a>
                  <a 
                    href="tel:097010224137" 
                    className="inline-flex items-center border-2 border-[#0A66C2] text-[#0A66C2] px-6 py-3 rounded-full font-semibold hover:bg-[#0A66C2] hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-phone-line mr-2"></i>
                    0970 102 241 37
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-12">
            <div className="md:col-span-2">
              <div className="flex items-center mb-6">
                <span className="text-3xl font-bold text-[#0A66C2]" style={{ fontFamily: '"Pacifico", serif' }}>
                  StarSales
                </span>
              </div>
              <p className="text-gray-300 mb-6 max-w-md" style={{ fontFamily: '"Inter", sans-serif' }}>
                StarSales B.V. helpt ZZP en kleine bedrijven groeien met websites, Google Ads, social media advertenties en meer.
              </p>
              <div className="space-y-2 text-gray-300">
                <p>Mgr. Cornelis Veermanlaan 63</p>
                <p>1131 KE Volendam</p>
                <p>KvK: 97377562</p>
                <p>Tel: 0970 102 241 37</p>
                <p>E-mail: info@starsales.nl</p>
              </div>
            </div>
            <div>
              <h3 className="font-semibold mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Diensten
              </h3>
              <ul className="space-y-2 text-gray-300">
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">Websites</a></li>
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">Google Ads</a></li>
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">Social Media Ads</a></li>
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">SEO</a></li>
                <li><a href="#" className="hover:text-[#F57C00] transition-colors">Hosting</a></li>
              </ul>
            </div>
            <div>
              <h3 className="font-semibold mb-4" style={{ fontFamily: '"Poppins", sans-serif' }}>
                Links
              </h3>
              <ul className="space-y-2 text-gray-300">
                <li><a href="/privacy" className="hover:text-[#F57C00] transition-colors">Privacy</a></li>
                <li><a href="/cookies" className="hover:text-[#F57C00] transition-colors">Cookies</a></li>
                <li><a href="/voorwaarden" className="hover:text-[#F57C00] transition-colors">Voorwaarden</a></li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 StarSales B.V. Alle rechten voorbehouden.
            </p>
            <div className="flex space-x-4 mt-5 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-[#F57C00] transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#F57C00] transition-colors">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#F57C00] transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
